import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { uniqBy } from 'lodash';
import callApi, { callDownload } from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';
import { DELETE_REPORT_STRUCTURE_SUCCESS } from 'redux/modules/reportStructures';

// Actions
export const FETCH_REPORTS = 'FETCH_REPORTS';
export const FETCH_REPORTS_SUCCESS = 'FETCH_REPORTS_SUCCESS';
export const FETCH_REPORTS_FAIL = 'FETCH_REPORTS_FAIL';
export const FETCH_REPORT = 'FETCH_REPORT';
export const FETCH_REPORT_SUCCESS = 'FETCH_REPORT_SUCCESS';
export const FETCH_REPORT_FAIL = 'FETCH_REPORT_FAIL';
export const CREATE_REPORT = 'CREATE_REPORT';
export const CREATE_REPORT_SUCCESS = 'CREATE_REPORT_SUCCESS';
export const CREATE_REPORT_FAIL = 'CREATE_REPORT_FAIL';
export const UPDATE_REPORT = 'UPDATE_REPORT';
export const UPDATE_REPORT_SUCCESS = 'UPDATE_REPORT_SUCCESS';
export const UPDATE_REPORT_FAIL = 'UPDATE_REPORT_FAIL';
export const DELETE_REPORT = 'DELETE_REPORT';
export const DELETE_REPORT_SUCCESS = 'DELETE_REPORT_SUCCESS';
export const DELETE_REPORT_FAIL = 'DELETE_REPORT_FAIL';
export const GENERATE_REPORT = 'GENERATE_REPORT';
export const GENERATE_REPORT_SUCCESS = 'GENERATE_REPORT_SUCCESS';
export const GENERATE_REPORT_FAIL = 'GENERATE_REPORT_FAIL';
export const GENERATE_CLAIM_REPORT = 'GENERATE_CLAIM_REPORT';
export const GENERATE_CLAIM_REPORT_SUCCESS = 'GENERATE_CLAIM_REPORT_SUCCESS';
export const GENERATE_CLAIM_REPORT_FAIL = 'GENERATE_CLAIM_REPORT_FAIL';
export const GENERATE_INSURANCE_REPORT = 'GENERATE_INSURANCE_REPORT';
export const GENERATE_INSURANCE_REPORT_SUCCESS = 'GENERATE_INSURANCE_REPORT_SUCCESS';
export const GENERATE_INSURANCE_REPORT_FAIL = 'GENERATE_INSURANCE_REPORT_FAIL';

// Reducer
export default function reportsReducer(state = { data: [], count: 0, loading: 0 }, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_REPORTS:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_REPORTS_SUCCESS: {
      if (payload.push) {
        const newData = [
          ...state.data.slice(0, state.data.length),
          ...payload.data.slice(0, payload.data.length),
        ];
        return {
          ...state,
          count: payload.count,
          data: uniqBy(newData, 'ID'),
        };
      }
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_REPORTS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_REPORT:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_REPORT_SUCCESS:
    case CREATE_REPORT_SUCCESS: {
      let isPresent = false;
      let newCount = state.count;
      let newData = state.data.map((dataItem) => {
        if (dataItem.ID !== payload.ID) {
          return dataItem;
        }
        isPresent = true;
        return {
          ...dataItem,
          ...payload,
        };
      });
      if (!isPresent) {
        newCount += 1;
        newData = [
          payload,
          ...newData,
        ];
      }
      return {
        ...state,
        count: newCount,
        data: newData,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_REPORT_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case UPDATE_REPORT_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem.ID !== payload.ID) {
          return dataItem;
        }
        return {
          ...dataItem,
          ...payload,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_REPORT_STRUCTURE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem['Default Report Structure'].ID === payload.ID) {
          return {
            ...dataItem,
            'Default Report Structure': {},
          };
        }
        return dataItem;
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_REPORT_SUCCESS: {
      const index = state.data.findIndex(dataItem => dataItem.ID === payload.ID);
      const newData = [
        ...state.data.slice(0, index),
        ...state.data.slice(index + 1),
      ];
      return {
        ...state,
        count: state.count - 1,
        data: newData,
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchReports(payload) {
  return { type: FETCH_REPORTS, payload };
}

export function fetchReportsSuccess(payload) {
  return { type: FETCH_REPORTS_SUCCESS, payload };
}

export function fetchReportsFail(payload) {
  return { type: FETCH_REPORTS_FAIL, payload };
}

export function fetchReport(payload) {
  return { type: FETCH_REPORT, payload };
}

export function fetchReportSuccess(payload) {
  return { type: FETCH_REPORT_SUCCESS, payload };
}

export function fetchReportFail(payload) {
  return { type: FETCH_REPORT_FAIL, payload };
}

export function createReport(payload) {
  return { type: CREATE_REPORT, payload };
}

export function createReportSuccess(payload) {
  return { type: CREATE_REPORT_SUCCESS, payload };
}

export function createReportFail(payload) {
  return { type: CREATE_REPORT_FAIL, payload };
}

export function updateReport(payload) {
  return { type: UPDATE_REPORT, payload };
}

export function updateReportSuccess(payload) {
  return { type: UPDATE_REPORT_SUCCESS, payload };
}

export function updateReportFail(payload) {
  return { type: UPDATE_REPORT_FAIL, payload };
}

export function deleteReport(payload) {
  return { type: DELETE_REPORT, payload };
}

export function deleteReportSuccess(payload) {
  return { type: DELETE_REPORT_SUCCESS, payload };
}

export function deleteReportFail(payload) {
  return { type: DELETE_REPORT_FAIL, payload };
}

export function generateReport(payload) {
  return { type: GENERATE_REPORT, payload };
}

export function generateReportSuccess(payload) {
  return { type: GENERATE_REPORT_SUCCESS, payload };
}

export function generateReportFail(payload) {
  return { type: GENERATE_REPORT_FAIL, payload };
}

export function generateClaimReport(payload) {
  return { type: GENERATE_CLAIM_REPORT, payload };
}

export function generateClaimReportSuccess(payload) {
  return { type: GENERATE_CLAIM_REPORT_SUCCESS, payload };
}

export function generateClaimReportFail(payload) {
  return { type: GENERATE_CLAIM_REPORT_FAIL, payload };
}

export function generateInsuranceReport(payload) {
  return { type: GENERATE_INSURANCE_REPORT, payload };
}

export function generateInsuranceReportSuccess(payload) {
  return { type: GENERATE_INSURANCE_REPORT_SUCCESS, payload };
}

export function generateInsuranceReportFail(payload) {
  return { type: GENERATE_INSURANCE_REPORT_FAIL, payload };
}

// Requests
export function requestFetchReports({ limit, offset }) {
  return callApi(`report/main/?limit=${limit}&offset=${offset}`);
}

export function requestSearchReports({ limit, offset, filters, sortBy }) {
  return callApi('report/main/search/', 'POST', {
    filters,
    sort_by: [
      {
        name: 'ID',
        sort: 'desc',
      },
      ...sortBy || [],
    ],
    limit,
    offset,
  });
}

export function requestFetchReport(payload) {
  return callApi(`report/main/?id=${payload}`);
}

export function requestCreateReport(payload) {
  return callApi('report/main/', 'POST', payload);
}

export function requestUpdateReport(payload) {
  return callApi('report/main/', 'PATCH', payload);
}

export function requestDeleteReport(payload) {
  return callApi(`report/main/?id=${payload}`, 'DELETE');
}

export function requestGenerateReport({ ID, fileName, ...otherProps }) {
  if (ID) {  
    if (otherProps['Report Structure ID']) {
      return callDownload(`report/order_report/create_on_report/?Report%20ID=${ID}&Report%20Structure%20ID=${otherProps['Report Structure ID']}`, 'GET', fileName);
    } else {
      return callDownload(`report/order_report/create_on_report/?Report%20ID=${ID}`, 'GET', fileName);
    }
  }
  return callDownload('report/order_report/create_on_generate/', 'POST', fileName, otherProps);
}

export function requestGenerateClaimReport({ fileName, ...otherProps }) {
  return callDownload('report/claim_report/create_on_generate/', 'POST', fileName, otherProps);
}

export function requestGenerateInsuranceReport({ fileName, ...otherProps }) {
  return callDownload('report/used_insurance_report/create_on_generate/', 'POST', fileName, otherProps);
}

// Sagas
function* fetchReportsSaga(action) {
  const { triggerLoading, filters, sortBy } = action.payload;
  try {
    const res = filters || sortBy
      ? yield call(requestSearchReports, action.payload)
      : yield call(requestFetchReports, action.payload);
    if (res.count === 0) {
      yield put(fetchReportsSuccess({
        data: res.data,
        count: res.count,
        triggerLoading,
      }));
    } else if (action.payload.push) {
      yield put(fetchReportsSuccess({
        push: true,
        data: res.data,
        count: res.count,
        triggerLoading,
      }));
    } else {
      yield put(fetchReportsSuccess({
        data: res.data,
        count: res.count,
        triggerLoading,
      }));
    }
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchReportsFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* fetchReportSaga(action) {
  const { triggerLoading } = action.payload;
  try {
    const res = yield call(requestFetchReport, action.payload.ID);
    if (res.data.ID) {
      yield put(fetchReportSuccess({
        ...res.data,
        triggerLoading,
      }));
      yield put(fetchAccountInformationSuccess(res.user_info));
      yield put(fetchAppInfoSuccess(res.app_info));
    } else {
      yield put(fetchReportFail({
        triggerLoading,
      }));
    }
  } catch (err) {
    yield put(fetchReportFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* createReportSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreateReport, values);
    yield put(createReportSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Report successfully created',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createReportFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updateReportSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdateReport, values);
    yield put(updateReportSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Report successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(updateReportFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* deleteReportSaga(action) {
  const { ID } = action.payload;
  try {
    const res = yield call(requestDeleteReport, ID);
    yield put(deleteReportSuccess({ ID }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(deleteReportFail(err.data));
  }
}

function* generateReportSaga(action) {
  try {
    const res = yield call(requestGenerateReport, action.payload);
    if (res.error) {
      yield put(generateReportFail(res.error));
      yield put(addNotification({
        message: res.error,
        variant: 'info',
      }));
    } else {
      yield put(generateReportSuccess(res.data));
    }
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(generateReportFail(err.data));
    yield put(addNotification({
      message: err.data,
      variant: 'warning',
    }));
  }
}

function* generateClaimReportSaga(action) {
  try {
    const res = yield call(requestGenerateClaimReport, action.payload);
    if (res.error) {
      yield put(generateClaimReportFail(res.error));
      yield put(addNotification({
        message: res.error,
        variant: 'warning',
      }));
    } else {
      yield put(generateClaimReportSuccess(res.data));
    }
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(generateClaimReportFail(err.data));
    yield put(addNotification({
      message: err.data,
      variant: 'warning',
    }));
  }
}

function* generateInsuranceReportSaga(action) {
  try {
    const res = yield call(requestGenerateInsuranceReport, action.payload);
    if (res.error) {
      yield put(generateInsuranceReportFail(res.error));
      yield put(addNotification({
        message: res.error,
        variant: 'warning',
      }));
    } else {
      yield put(generateInsuranceReportSuccess(res.data));
    }
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(generateInsuranceReportFail(err.data));
    yield put(addNotification({
      message: err.data,
      variant: 'warning',
    }));
  }
}

export function* reportsSaga() {
  yield takeLatest(FETCH_REPORTS, fetchReportsSaga);
  yield takeEvery(FETCH_REPORT, fetchReportSaga);
  yield takeEvery(CREATE_REPORT, createReportSaga);
  yield takeEvery(UPDATE_REPORT, updateReportSaga);
  yield takeEvery(DELETE_REPORT, deleteReportSaga);
  yield takeEvery(GENERATE_REPORT, generateReportSaga);
  yield takeEvery(GENERATE_CLAIM_REPORT, generateClaimReportSaga);
  yield takeEvery(GENERATE_INSURANCE_REPORT, generateInsuranceReportSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/reports.js